import type { ExtensionWorkerStatus } from "../../../api/extension-worker-status";

export type WorkerStallKind = "no_device" | "offline" | "not_started";

export interface WorkerStall {
  kind: WorkerStallKind;
  waiting: number;
  since: string | null;
}

/** Searches are waiting but no extension is running the queue loop. */
export function workerStall(worker: ExtensionWorkerStatus | null | undefined, waiting: number): WorkerStall | null {
  if (!worker || waiting <= 0 || worker.devicesSearching > 0) return null;
  const kind: WorkerStallKind = worker.devices === 0 ? "no_device"
    : worker.devicesOnline === 0 ? "offline"
    : "not_started";
  return { kind, waiting, since: worker.oldestQueuedAt };
}

export function waitingSince(iso: string | null, now = Date.now()): string {
  if (!iso) return "";
  const diff = now - new Date(iso).getTime();
  if (!Number.isFinite(diff) || diff < 60_000) return "";
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 60) return ` da ${minutes} ${minutes === 1 ? "minuto" : "minuti"}`;
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return ` da ${hours} ${hours === 1 ? "ora" : "ore"}`;
  return ` da ${Math.floor(hours / 24)} giorni`;
}

export function workerStallMessage(stall: WorkerStall, now = Date.now()): { title: string; text: string } {
  const waiting = `${stall.waiting === 1 ? "1 ricerca" : `${stall.waiting} ricerche`} in attesa${waitingSince(stall.since, now)}`;
  if (stall.kind === "no_device") {
    return {
      title: "Nessuna estensione abbinata",
      text: `${waiting}. Le ricerche su SISTER le esegue l’estensione Legacy in Chrome: installala e abbinala dalla pagina Estensione.`,
    };
  }
  if (stall.kind === "offline") {
    return {
      title: "Estensione spenta",
      text: `${waiting}. Apri Chrome sul computer con l’estensione Legacy, poi apri l’estensione e premi «Prepara SISTER e avvia».`,
    };
  }
  return {
    title: "Ricerca su SISTER non avviata",
    text: `L’estensione è collegata e Chrome è aperto, ma non sta cercando: ${waiting}. `
      + "Apri l’estensione Legacy, compila «Nome richiedente» e premi «Prepara SISTER e avvia», "
      + "poi fai l’accesso SPID nella scheda Agenzia Entrate che si apre. Lascia aperta la scheda SISTER finché le ricerche finiscono.",
  };
}
